import React from 'react';
import { useApp } from '../context/AppContext';
import { useTranslation } from 'react-i18next';

export default function Settings() {
  const { user } = useApp();
  const { t } = useTranslation();

  return (
    <div className="page-content">
      <h1 style={{ fontFamily:'var(--font-head)', fontSize:'1.75rem', fontWeight:800, color:'var(--primary)', marginBottom:'2rem' }}>
        {t('settings.title')}
      </h1>
      <div className="card" style={{ maxWidth:500 }}>
        <h3 style={{ fontFamily:'var(--font-head)', fontWeight:700, marginBottom:'1.25rem' }}>
          {t('settings.profileTitle')}
        </h3>
        <div style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
          {[
            [t('settings.fields.name'),    user?.full_name || '—'],
            [t('settings.fields.email'),   user?.email     || '—'],
            [t('settings.fields.company'), user?.company   || '—'],
          ].map(([l, v]) => (
            <div key={l}>
              <label className="label">{l}</label>
              <div className="input" style={{ background:'var(--surface-low)', display:'flex', alignItems:'center' }}>{v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
